/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// sweetalert2 components
import Swal from "sweetalert2";
import Template from "../Template";

// Sweet Alerts page components
// import Template from "layouts/pages/sweet-alerts/components/Template";

function Success({ action, text1, text2 }) {
  const showAlert = () => {
    Swal.fire(text1, text2, "success")
    action()

  };

  return <Template title="A success message" action={showAlert} />;
}

export default Success;
